import { Box, Chip, styled, Tooltip, withTheme } from '@material-ui/core'
import dayjs from 'dayjs'
import React from 'react'
import { BiQuestionMark } from 'react-icons/bi'
import { IconType } from 'react-icons/lib'
import { TableCellProps } from 'react-virtualized'

import { Provider } from 'src/api/gen'
import { getJurisdictionTimezone } from 'src/commons/temporalHelpers'

import { CellLink } from './Cells'

export const TableTag = styled(withTheme(Chip))(({ theme }) => ({
  background: theme.palette.grey[300],
  border: 0,
  borderRadius: 8,
  height: 23,
  padding: '4px 8px',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '15px',
}))

export function enumCellRenderer(cellProps: TableCellProps, translator: (key: any) => string) {
  const { cellData } = cellProps
  const cellContent = (cellData && translator(cellData)) ?? ''

  return <div>{cellContent}</div>
}

export function iconCellRenderer(
  cellProps: TableCellProps,
  translator: (key: any) => string,
  iconMap: (key: any) => IconType
) {
  const { cellData } = cellProps
  const tooltipContent = (cellData && translator(cellData)) ?? cellData
  const CurrentIcon = (cellData && iconMap(cellData)) ?? BiQuestionMark

  return (
    <Tooltip title={tooltipContent} aria-label={tooltipContent}>
      <Box>
        <CurrentIcon style={{ fontSize: 20, color: 'black', opacity: 0.6 }} />
      </Box>
    </Tooltip>
  )
}

export function providerCellRenderer(cellProps: TableCellProps, providers: Provider[]) {
  const providerId = cellProps.cellData as string
  const provider = providers.find((p) => p.id === providerId)

  if (!provider) {
    return <div>{providerId}</div>
  }

  return (
    <CellLink url={`/providers/${provider.id}`}>
      <Box
        style={{
          backgroundImage: `url(${provider?.logo || '/img/img-placeholder.svg'})`,
          textAlign: 'center',
          height: 25,
          maxHeight: 25,
          maxWidth: 80,
          width: '100%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </CellLink>
  )
}

export function tagCellRenderer(
  cellProps: TableCellProps,
  translator: (key: any) => string,
  colorMap: (key: any) => { background: string; text: string }
) {
  const { cellData } = cellProps
  const cellContent = (cellData && translator(cellData)) ?? ''
  const colors = colorMap(cellData) ?? {}

  return <TableTag size="small" label={cellContent} style={{ color: colors.text, background: colors.background }} />
}

export function dateCellRenderer(cellProps: TableCellProps) {
  const { cellData } = cellProps
  let cellContent = ''

  if (cellData) {
    cellContent = dayjs(cellData).tz(getJurisdictionTimezone()).format('L LT')
  }

  return <div>{cellContent}</div>
}
